<script>
import axios from 'axios'
import ModalBus from '@/eventBus'

export default {
  name: 'BuyBook',

  props: {
    countriesList: {
      type: Array,
      required: true,
    },

    linkLabel: {
      type: String,
      required: false,
      default: null,
    },

    link: {
      type: String,
      required: false,
      default: null,
    },

    title: {
      type: String,
      required: true,
    },

    content: {
      type: String,
      required: true,
    },

    showForm: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      form: {
        token: null,
        lastname: window.Laravel.user?.lastname,
        firstname: window.Laravel.user?.firstname,
        email: window.Laravel.user?.email,
        country: window.Laravel.user?.country,
        phone: window.Laravel.user?.phone,
      },

      sending: false,
      successMessage: '',
      errorMessage: '',
      errors: undefined,
    }
  },

  methods: {
    closePopup() {
      ModalBus.emit('close')
    },

    handleSubmit() {
      this.sending = true
      this.errorMessage = ''
      this.errors = undefined
      this.successMessage = ''

      this.$recaptcha('buyBook').then((token) => {
        this.form.token = token
        axios
          .post('/submission/buy-book', this.form)
          .then((response) => {
            this.successMessage = response.data.message
            window.location.href = response.data.url
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors || {}
            } else if (error.response.status === 500 || error.response.status === 401) {
              this.errorMessage = error.response.data.message
            }
          })

        this.sending = false
      })
    },
  },
}
</script>

<template>
  <div class="w-11/12 rounded-xl bg-white">
    <div class="flex items-center justify-between border-b-2 border-light/25 p-5">
      <span class="max-w-10/12 font-poppins text-xl font-medium lg:text-secondary">
        {{ title }}
      </span>
      <button
        class="relative h-10 w-10 rounded-full bg-secondary focus:outline-none"
        @click="closePopup">
        <div
          class="absolute left-1/2 top-1/2 flex h-1/2 w-1/2 -translate-x-1/2 -translate-y-1/2 flex-col items-end justify-between">
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full rotate-45 rounded bg-white"></div>
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full -rotate-45 rounded bg-white"></div>
        </div>
      </button>
    </div>

    <div class="p-5">
      <p
        class="mt-4 text-light"
        v-html="content"></p>
      <div class="mt-8 flex w-full flex-col">
        <form
          v-if="showForm"
          class="flex flex-col p-5 md:py-0"
          @submit.prevent="handleSubmit">
          <div
            v-if="errorMessage"
            class="relative mb-3 mt-3 rounded-lg bg-red-100 px-3 py-3 text-sm text-red-700">
            {{ errorMessage }}
          </div>

          <div
            v-if="successMessage"
            class="relative mb-3 mt-3 rounded-lg bg-emerald-100 px-3 py-3 text-sm text-emerald-700">
            {{ successMessage }}
          </div>
          <div class="grid grid-cols-2 gap-x-4">
            <label class="form__label">
              <span>{{ $t('commons.quoteForm.customerInfos.form.lastname.label') }}</span>
              <input
                v-model="form.lastname"
                :placeholder="$t('commons.quoteForm.customerInfos.form.lastname.placeholder')"
                class="form__input bg-white lg:bg-white"
                name="lastname"
                type="text" />
              <span
                v-if="errors && errors['lastname']"
                class="text-xs text-red-500"
                >{{ errors['lastname'][0] }}</span
              >
            </label>
            <label class="form__label">
              <span>{{ $t('commons.quoteForm.customerInfos.form.firstname.label') }}</span>
              <input
                v-model="form.firstname"
                :placeholder="$t('commons.quoteForm.customerInfos.form.firstname.placeholder')"
                class="form__input bg-white lg:bg-white"
                name="firstname"
                type="text" />
              <span
                v-if="errors && errors['firstname']"
                class="text-xs text-red-500"
                >{{ errors['firstname'][0] }}</span
              >
            </label>
          </div>
          <div class="grid grid-cols-2 gap-x-4">
            <label class="form__label">
              <span>{{ $t('commons.quoteForm.customerInfos.form.email.label') }}</span>
              <input
                v-model="form.email"
                :placeholder="$t('commons.quoteForm.customerInfos.form.email.placeholder')"
                :disabled="$root.user.email"
                :class="$root.user.email ? 'bg-transparent' : 'bg-white lg:bg-white'"
                class="form__input"
                name="email"
                type="text" />
              <span
                v-if="errors && errors['email']"
                class="text-xs text-red-500"
                >{{ errors['email'][0] }}</span
              >
            </label>
            <label class="form__label">
              <span>{{ $t('commons.quoteForm.customerInfos.form.phone.label') }}</span>
              <input
                v-model="form.phone"
                :placeholder="$t('commons.quoteForm.customerInfos.form.phone.placeholder')"
                class="form__input bg-white lg:bg-white"
                name="phone"
                type="text" />
              <span
                v-if="errors && errors['phone']"
                class="text-xs text-red-500"
                >{{ errors['phone'][0] }}</span
              >
            </label>
          </div>
          <label class="form__label">
            <span>Pays de résidence</span>
            <select
              v-model="form.country"
              class="form__input bg-lightgray lg:bg-white">
              <option
                disabled
                :value="null">
                Sélectionner
              </option>
              <option
                v-for="country in countriesList"
                :value="country.value">
                {{ country.label }}
              </option>
            </select>
            <span
              v-if="errors && errors['country']"
              class="text-xs text-red-500"
              >{{ errors['country'][0] }}</span
            >
          </label>
          <button
            :disabled="sending"
            class="btn mt-8 px-12 md:w-auto"
            type="submit">
            <i
              v-if="sending"
              class="fa fa-spinner animate-spin"></i>
            {{ $t('buttons.send') }}
          </button>
        </form>
        <a
          v-else
          :href="link"
          class="btn mb-8 w-full"
          target="_blank"
          rel="noopener noreferrer">
          {{ linkLabel }}
        </a>
      </div>
    </div>
  </div>
</template>
